import React, { Fragment } from 'react'
import FindmysizeComponent from '../../components/FindmysizeComponent'
import AyudaComponent from './components/AyudaComponent'

export default function FindsizePage() {
  return (
    <Fragment>
        <div className='container'>
            <div className='py-2 py-md-4 py-xl-5'>
                <h2 className='text-center text-uppercase'>ENCUENTRA TU TALLA</h2>
            </div>
            <div className='py-2 py-md-4 py-xl-5 px-lg-5 text-center'>
                <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>
            </div>
            <FindmysizeComponent/>
        </div>
        <AyudaComponent/>
    </Fragment>
  )
}
